import { CreateTransactionProduct } from "./createTransactionProduct";

export class CreateTransaction {
  startDate: Date;
  validityDate: Date;
  transactionPrivateNode?: string;
  companyId: number;
  kindId: number
  userId: number;
  personId: number;
  docNo?: string;
  projectId?: number;
  requestTaskId?: number;
  descriptionId?: number;
  createTransactionProducts: CreateTransactionProduct[];
  isMailConfirmed?: boolean = null;
  expenseId?: number = null;
}

/*
{
  "transactionCraetedAt": "2024-08-06T07:54:14.539Z",
  "validityDate": "2024-08-06T07:54:14.539Z",
  "status": 0,
  "transactionPrivateNode": "string",
  "kindId": 0,
  "companyId": 0,
  "appUserId": 0,
  "personId": 0,
  "requestTaskId": 0,
  "createTransactionProducts": [
    {
      "transactionManagementId": 0,
      "productId": 0,
      "warehouseId": 0,
      "productCount": 0,
      "productPrice": 0,
      "taxId": 0,
      "discountRate": 0,
      "currencyId": 0,
      "description": "string"
    }
  ]
}
*/